export default __webpack_public_path__ + "static/media/about_direct_learnmore_2.4e65edf0.png";